export default "__VITE_ASSET__8nRVvIs1__ 400w, __VITE_ASSET__DhaJFl3x__ 800w, __VITE_ASSET__B4$0J79T__ 1024w";